import { createAction, props } from '@ngrx/store';

export const setOnlyShowUnread = createAction(
  '[Notification Feed Component] Set Only Show Unread',
  props<{ onlyShowUnread: boolean }>(),
);
